import { applianceData, attachAdminComponent, cabinetData } from 'jms-domain'
import { partData } from 'jms-domain/src/data/parts'

import { assertNumber, genericDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain'

export const getDealerPriceInstanceName = (sku: string) => `cabinetPriceDealer_${sku}`
export const getRetailPriceInstanceName = (sku: string) => `cabinetPriceEndUser_${sku}`
export const getPackageDepthInstanceName = (sku: string) => `cabinetPackageDepth_${sku}`
export const getPackageHeightInstanceName = (sku: string) => `cabinetPackageHeight_${sku}`
export const getPackageWidthInstanceName = (sku: string) => `cabinetPackageWidth_${sku}`
export const getPackageWeightInstanceName = (sku: string) => `cabinetPackageWeight_${sku}`

export const adminProductComponents = [
  ...Object.values(cabinetData).flatMap(item => {
    return [
      attachAdminComponent
        .withEntity('Cabinet')
        .withComponent(genericDimensionComponent, getDealerPriceInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.dealerPrice],
            value => ({
              min: 0,
              max: 100000,
              value,
              unit: '$',
            })
          ),
          state => {
            assertNumber(state.value)
            return { dealerPrice: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Cabinet')
        .withComponent(genericDimensionComponent, getRetailPriceInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.retailPrice],
            value => ({
              min: 0,
              max: 100000,
              value,
              unit: '$',
            })
          ),
          state => {
            assertNumber(state.value)
            return { retailPrice: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Cabinet')
        .withComponent(genericDimensionComponent, getPackageDepthInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageDepth],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageDepth: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Cabinet')
        .withComponent(genericDimensionComponent, getPackageHeightInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageHeight],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageHeight: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Cabinet')
        .withComponent(genericDimensionComponent, getPackageWidthInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageWidth],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageWidth: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Cabinet')
        .withComponent(genericDimensionComponent, getPackageWeightInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageWeight],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'lbs',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageWeight: state.value }
          }
        ),
    ]
  }),

  ...Object.values(partData).flatMap(item => {
    return [
      attachAdminComponent
        .withEntity('Part')
        .withComponent(genericDimensionComponent, getDealerPriceInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.dealerPrice],
            value => ({
              min: 0,
              max: 100000,
              value,
              unit: '$',
            })
          ),
          state => {
            assertNumber(state.value)
            return { dealerPrice: state.value }
          }
        ),
      attachAdminComponent
        .withEntity('Part')
        .withComponent(genericDimensionComponent, getRetailPriceInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.retailPrice],
            value => ({
              min: 0,
              max: 100000,
              value,
              unit: '$',
            })
          ),
          state => {
            assertNumber(state.value)
            return { retailPrice: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Part')
        .withComponent(genericDimensionComponent, getPackageDepthInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageDepth],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageDepth: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Part')
        .withComponent(genericDimensionComponent, getPackageHeightInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageHeight],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageHeight: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Part')
        .withComponent(genericDimensionComponent, getPackageWidthInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageWidth],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageWidth: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Part')
        .withComponent(genericDimensionComponent, getPackageWeightInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageWeight],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'lbs',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageWeight: state.value }
          }
        ),
    ]
  }),

  ...Object.values(applianceData).flatMap(item => {
    return [
      attachAdminComponent
        .withEntity('Appliance')
        .withComponent(genericDimensionComponent, getDealerPriceInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.dealerPrice],
            value => ({
              min: 0,
              max: 100000,
              value,
              unit: '$',
            })
          ),
          state => {
            assertNumber(state.value)
            return { dealerPrice: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Appliance')
        .withComponent(genericDimensionComponent, getRetailPriceInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.retailPrice],
            value => ({
              min: 0,
              max: 100000,
              value,
              unit: '$',
            })
          ),
          state => {
            assertNumber(state.value)
            return { retailPrice: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Appliance')
        .withComponent(genericDimensionComponent, getPackageDepthInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageDepth],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageDepth: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Appliance')
        .withComponent(genericDimensionComponent, getPackageHeightInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageHeight],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageHeight: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Appliance')
        .withComponent(genericDimensionComponent, getPackageWidthInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageWidth],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'in',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageWidth: state.value }
          }
        ),

      attachAdminComponent
        .withEntity('Appliance')
        .withComponent(genericDimensionComponent, getPackageWeightInstanceName(item.sku))
        .attach(
          memoEval(
            self => [self.packageWeight],
            value => ({
              min: 0,
              max: 1000,
              value,
              unit: 'lbs',
            })
          ),
          state => {
            assertNumber(state.value)
            return { packageWeight: state.value }
          }
        ),
    ]
  }),
]
